// const stroke =
// '1px 1px #000,1px 0px #000,-1px 0px #000,-1px -1px #000,0px -1px #000,0px 1px #000,-1px 1px #000,1px -1px #000';
const shadow = '1px 1px #333,1px 0px #333,1px 0px #333';

const softWarTheme = {
  palette: {
    common: {
      black: '#000',
      white: '#fff'
    },
    background: {
      paper: '#fff',
      default: '#fff'
    },
    primary: {
      light: '#6ec26b',
      main: '#3c913e',
      dark: '#006211',
      contrastText: '#fff'
    },
    secondary: {
      light: '#5ddaf5',
      main: '#00a8c2',
      dark: '#007992',
      contrastText: '#fff'
    },
    // primary: {
    //   light: '#5ddaf5',
    //   main: '#00a8c2',
    //   dark: '#007992',
    //   contrastText: '#fff'
    // },
    // secondary: {
    //   light: '#6ec26b',
    //   main: '#3c913e',
    //   dark: '#006211',
    //   contrastText: '#fff'
    // },
    error: {
      light: '#e57373',
      main: '#f44336',
      dark: '#d32f2f',
      contrastText: '#fff'
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.54)',
      disabled: 'rgba(0, 0, 0, 0.38)',
      hint: 'rgba(0, 0, 0, 0.38)'
    }
  },
  typography: {
    useNextVariants: true,
    fontFamily: "'Titillium Web', 'Roboto', sans-serif",
    fontSize: 16,
    subtitle1: {
      fontStretch: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      fontWeight: '700',
      fontSize: 18,
      fontStyle: 'italic',
      marginBottom: 16
    },
    body1: {
      fontSize: '18px'
    },
    body2: {
      fontSize: '16px',
      fontWeight: '600',
      fontStyle: 'italic'
    },
    h2: {
      fontFamily: 'GoodDog Plain',
      fontSize: '60px',
      textShadow: shadow
    },
    h3: {
      fontSize: '28px'
    },
    h6: {
      fontWeight: '700',
      fontSize: 18,
      fontStyle: 'italic'
    },
    h1: {
      fontSize: '50px'
    },
    h4: {
      fontFamily: 'GoodDog Plain',
      fontSize: 50,
      textShadow: shadow,
      fontWeight: 'bold'
    }
  }
};

export default softWarTheme;
